<template>
    <!-- Confirms archiving a group report. Hand-rolled rather than
         NotificationModal because that renders no backdrop. Teleported so no
         parent can clip it, and above slide-overs so it never lands behind one. -->
    <teleport to="body">
        <div    v-if="show"
                class="fixed inset-0 z-[60] flex items-center justify-center p-4"
                role="dialog"
                aria-modal="true"
                aria-labelledby="archive_group_report_title"
                @keydown.esc="cancel"
        >
            <div    class="absolute inset-0 bg-gray-500 bg-opacity-75"
                    @click="cancel"
            ></div>

            <div class="relative w-full max-w-lg overflow-clip rounded-lg bg-white shadow-xl">
                <div class="flex items-start gap-4 px-6 pb-6 pt-6">
                    <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-red-100">
                        <tabler-icon    name="alertTriangle"
                                        size-class="h-6 w-6"
                                        class="text-red-600"
                        ></tabler-icon>
                    </div>

                    <div class="min-w-0 pt-1">
                        <h3 id="archive_group_report_title"
                            class="m-0 p-0 text-left text-lg font-semibold leading-6 text-gray-900"
                        >Archive "{{ name }}"?</h3>

                        <p class="m-0 mt-2 text-sm leading-6 text-gray-600">
                            This group report will stop sending and be removed from the list.
                            Reports it has already sent stay available in Report History.
                        </p>
                    </div>
                </div>

                <div class="flex items-center justify-end gap-3 border-t border-gray-200 bg-gray-50 px-6 py-4">
                    <button type="button"
                            :disabled="busy"
                            class="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition-colors duration-150 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-50"
                            @click="cancel"
                    >Cancel</button>

                    <button type="button"
                            :disabled="busy"
                            class="inline-flex items-center justify-center gap-2 rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-red-600"
                            @click="$emit('confirm')"
                    >
                        <tabler-icon    v-if="busy"
                                        name="loader"
                                        size-class="h-4 w-4 animate-spin"
                        ></tabler-icon>
                        {{ busy ? 'Archiving' : 'Archive' }}
                    </button>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script>
import TablerIcon from "@/components/elements/TablerIcon.vue"

export default {
    name: "ArchiveGroupReportModal",
    components: {TablerIcon},
    emits: ['update:show', 'confirm'],
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
        },
        // The archive request is in flight.
        busy: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        cancel() {
            if (! this.busy) {
                this.$emit('update:show', false)
            }
        },
    },
}
</script>
